<template lang="pug">
  .pane.cost-calculator(:class="objectClass")
    .pane__header Расчет стоимости

    Table(
      class="pane__body"
      v-for="(place, eventId) in places"
      @update="placesUpdateHandler"
      :event="getCurrentEventById({id: eventId})"
      :place="place"
      :key="eventId"
    )

    .pane__footer.cost-calculator__total
      .cost-calculator__total-label Итого
      .cost-calculator__total-sum {{priceToString(totalPrice)}}

</template>

<script>
import {mapGetters, mapActions} from "vuex";
import priceToString from "@/mixins/price-to-string";
import Table from "@/components/CostCalculator/Table";

export default {
  name: 'CostCalculator',
  mixins: [priceToString],
  components: {Table},
  data() {
    return {
      totalPrice: 0,
    }
  },
  computed: {
    ...mapGetters('event', {
      isNoCurrentEvents: 'isNoCurrentEvents',
      getTotalPrice: 'getTotalPrice',
      getCurrentEventById: 'getCurrentEventById',
    }),
    ...mapGetters('places', {
      places: 'getPlaces',
    }),
    objectClass() {
      return {
        'pane--closed': this.isNoCurrentEvents
      }
    },
  },
  methods: {
    ...mapActions('places', ['updatePlaces']),
    placesUpdateHandler({eventId, full, discount}) {
      this.updatePlaces({eventId, full, discount});
      this.calcTotalPrice();
    },
    // Подсчет итоговой суммы для всех мест всех событий
    calcTotalPrice() {
      let sum = 0;
      for (const eventId in this.places) {
        sum += this.getTotalPrice({
          eventId: parseInt(eventId),
          fullPlaces: this.places[eventId].full,
          discountPlaces: this.places[eventId].discount,
        });
      }
      this.totalPrice = sum;
    },
  }
}
</script>
